module.exports = __webpack_public_path__ + "img/hic-neoplasm-female.1b46d01a.png";